<template>
  <modal
    :title="title"
    class-name="small-modal"
    :saving="saving"
    @submit="handleSubmit"
    @hide-modal="$emit('hide-modal')"
  >
    <div class="d-flex gap-3">
      <text-field
        v-model="formData.first_name"
        name="First Name"
        :errorMessage="
          v$.formData.first_name
            ? firstErrorMessage(v$.formData.first_name)
            : ''
        "
        auto-focus
      ></text-field>
      <text-field
        v-model="formData.last_name"
        name="Last Name"
        :errorMessage="
          v$.formData.last_name ? firstErrorMessage(v$.formData.last_name) : ''
        "
      ></text-field>
      <text-field
        v-model="formData.phone"
        v-mask="'(###) ###-####'"
        :errorMessage="
          v$.formData.phone ? firstErrorMessage(v$.formData.phone) : ''
        "
        name="Phone Number"
        placeholder="(XXX) XXX-XXXX"
      ></text-field>
    </div>
  </modal>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { cloneObj } from "@/lib/helpers.js";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
  components: {
    TextField,
    Modal
  },
  props: {
    crewMember: {
      type: Object,
      default: null
    },
    link: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      formData: {
        first_name: { required, $autoDirty: true },
        last_name: { required, $autoDirty: true },
        phone: {
          required,
          $autoDirty: true,
          phoneValid: helpers.withMessage(
            "The Phone Number field must contain 10 digits",
            (value) => (value?.match(/\d/g) || []).length === 10
          )
        }
      }
    };
  },
  data() {
    return {
      formData: {
        first_name: "",
        last_name: "",
        phone: ""
      },
      saving: false
    };
  },
  computed: {
    title() {
      return this.crewMember ? "Edit Crew Member" : "Create Crew Member";
    }
  },
  mounted() {
    if (this.crewMember) {
      this.formData = cloneObj(this.crewMember);
    }
  },
  methods: {
    firstErrorMessage,
    ...mapActions(["upsertCrewMember"]),
    async handleSubmit() {
      const validated = await this.v$.$validate();
      if (validated) {
        this.saving = true;
        // Use either create or edit link here
        this.upsertCrewMember({
          link: this.link,
          data: this.formData
        })
          .then(() => {
            const verb = this.crewMember ? "updated" : "created";
            window.notify.success(`Crew Member ${verb} successfully!`);
            EventBus.$emit("refresh-work-crews");
            this.$emit("hide-modal");
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
